module.exports = __webpack_public_path__ + "static/media/EXPLORE.e44a6e4d.svg";